module.exports = __webpack_public_path__ + "img/kate_macK211064.b65581a0.jpg";